/* eslint-env jest */
import R from 'ramda'

const LIKE_OF_ANY_DISPLAY_TYPE = 'Like Of Any'
const LIKE_OF_ANY_WIDGET_TYPE = 'LIKE_OF_ANY'

const isLikeOfAnyWidgetTrigger = R.propEq('type', LIKE_OF_ANY_WIDGET_TYPE)

const convertLikeOfAnyWidgetToFormTrigger = R.applySpec({
  type: R.always(LIKE_OF_ANY_DISPLAY_TYPE),
  tweetIdList: R.prop('data')
})

export { isLikeOfAnyWidgetTrigger, convertLikeOfAnyWidgetToFormTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/widget-to-form/like_of_any.js